import { useEffect, useCallback, useRef } from 'react';
import { useDispatch } from 'react-redux';
import { socketManager } from 'utils/socketManager';
import { badgeApi } from 'store/services/badge/badgeApi';
import { BadgeEarnedEvent, BadgeLostEvent } from 'types/interfaces/badge';
import { showBadgeEarnedToast } from 'components/BadgeEarnedToast/BadgeEarnedToast';

interface UseBadgeSocketOptions {
  enabled?: boolean;
}

export const useBadgeSocket = (options: UseBadgeSocketOptions = {}): void => {
  const { enabled = true } = options;
  const dispatch = useDispatch();
  const hasAcquiredRef = useRef(false);

  const handleBadgeEarned = useCallback(
    (payload: BadgeEarnedEvent) => {
      console.log('[BadgeSocket] Received badge:earned', payload);
      showBadgeEarnedToast(payload);
      dispatch(badgeApi.util.invalidateTags(['UserBadges', 'BadgeSummary']));
    },
    [dispatch]
  );

  const handleBadgeLost = useCallback(
    (payload: BadgeLostEvent) => {
      console.log('[BadgeSocket] Received badge:lost', payload);
      dispatch(badgeApi.util.invalidateTags(['UserBadges', 'BadgeSummary']));
    },
    [dispatch]
  );

  useEffect(() => {
    if (!enabled) return;

    hasAcquiredRef.current = true;
    const socket = socketManager.acquireSocket();

    socket.on('badge:earned', handleBadgeEarned);
    socket.on('badge:lost', handleBadgeLost);

    return () => {
      socket.off('badge:earned', handleBadgeEarned);
      socket.off('badge:lost', handleBadgeLost);

      if (hasAcquiredRef.current) {
        socketManager.releaseSocket();
        hasAcquiredRef.current = false;
      }
    };
  }, [enabled, handleBadgeEarned, handleBadgeLost]);
};

export default useBadgeSocket;
